import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const VehicleRecord: React.FC = () => {
  return (
    <PlaceholderPage
      title="Vehicle Record"
      description="Search and view comprehensive vehicle records"
    />
  );
};

export default VehicleRecord;
